import FullHeightContainer from '../../component/common/FullHeightContainer';
import BottomNavigationV2 from '../../component/common/BottomNavigationV2';
import AllVideos from '../../component/history/AllVideos';
import FavoriteVideos from '../../component/history/FavoriteVideos';
import Intelligences from '../../component/history/Intelligences';

function HistoryPage() {
  return (
    <FullHeightContainer>
      <div className="flex py-[12px] px-[20px] h-[64px] justify-between w-full items-center">
        <div className="text-[22px] font-bold text-[#2D2D2D] leading-[30px]">성장기록</div>
      </div>
      <div className="pageInner" style={{ padding: '0 0 50px' }}>
        <AllVideos />
        <FavoriteVideos />
        <Intelligences />
      </div>
      <BottomNavigationV2 />
    </FullHeightContainer>
  );
}

export default HistoryPage;
